<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Extra options</span>
        <h3 class="page-title">New Extra Option</h3>
      </div>
    </div>

    <d-card class="card-small">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col lg="6">
              <d-form>
                <d-alert theme="danger" show v-if="submitted && (!success && !errors.length)">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span>An unexpected error occurred.</span>
                </d-alert>

                <div class="form-group">
                  <v-multi-language label="Title" v-model="fields.title" :class="{ 'is-invalid': hasError('title') }" />
                  <span class="invalid-feedback" v-if="hasError('title')">{{ getError('title') }}</span>
                </div>

                <div class="form-group">
                  <v-multi-language label="Remark" v-model="fields.remark" :class="{ 'is-invalid': hasError('description') }" />
                  <span class="invalid-feedback" v-if="hasError('description')">{{ getError('description') }}</span>
                </div>

                <div class="form-group">
                  <label for="icon">Icon</label>

                  <div class="custom-file mb-3">
                    <input type="file" class="custom-file-input" id="icon" ref="icon" @change="onIconUpload" :class="{ 'is-invalid': hasError('icon') }" />
                    <label class="custom-file-label" for="icon">
                      <span v-if="fields.icon.file">{{ fields.icon.fileName }}</span>
                      <span v-else>Choose file...</span>
                    </label>

                    <span class="invalid-feedback" v-if="hasError('icon')">{{ getError('icon') }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <d-checkbox v-model="fields.cancelable" style="font-weight: 400;">Cancelable</d-checkbox>
                </div>

                <d-button type="submit" @click="onSubmit" :disabled="submitting">Create Extra Option</d-button>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </d-container>
</template>

<script>
export default {
  methods: {
    hasError: function (field) {
      return this.errors.find(error => error.field === field);
    },

    getError: function (field) {
      return this.errors.find(error => error.field === field).message;
    },

    onIconUpload: function (event) {
      if (event.target.files.length > 0) {
        this.fields.icon = {
          fileName: event.target.files[0].name,
          file: event.target.files[0],
        };
      }
    },

    onSubmit: async function (event) {
      event.preventDefault();

      if (!this.fields.icon.file) {
        this.errors = [
          {
            message: 'The icon cannot be blank',
            field: 'icon',
          }
        ];

        return;
      }

      const remark = [];
      const title = [];

      Object.entries(this.fields.title).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        title.push({
          language: language,
          text: text,
        });
      });

      Object.entries(this.fields.remark).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        remark.push({
          language: language,
          text: text,
        });
      });

      this.submitting = true;
      this.submitted = false;
      this.errors = [];

      const data = await this.$apollo.mutate({
        mutation: require('../../graphql/CreateExtraOption.gql'),
        variables: {
          title: title,
          remark: remark,
          icon: this.fields.icon.file,
          cancelable: this.fields.cancelable,
        },
      });

      this.submitting = false;
      this.submitted = true;
      this.success = data.data.createExtraOption.success;

      if (this.success) {
        this.$router.push({
          name: 'extraOptions.single',
          params: {
            id: data.data.createExtraOption.extraOption.id,
          },
        });
      } else {
        this.errors = data.data.createExtraOption.errors;
      }
    },
  },

  data: function () {
    return {
      submitting: false,
      submitted: false,
      success: false,
      errors: [],
      fields: {
        cancelable: true,
        title: [],
        remark: [],
        icon: {
          fileName: '',
          file: undefined,
        },
      },
    };
  },
};
</script>
